var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ul><li ng-repeat=\"gruppe in vm.zielgruppenChoices\" ng-if=\"vm.parameter[vm.key].wert.indexOf(gruppe.pk) &gt;= 0\">{{ gruppe.zgr_kbez }}<ul ng-if=\"gruppe.untergruppen.length &gt;= 0\"><li ng-repeat=\"untergruppe in gruppe.untergruppen\" ng-if=\"vm.parameter[vm.key].wert.indexOf(untergruppe.pk) &gt;= 0\">{{ untergruppe.zgr_kbez }}</li></ul></li></ul>");;return buf.join("");
}